<template>
  <div class="mx-auto mt-20 md:w-2/6 w-full p-8">
    <h1 class="font-bold text-4xl">Logga in</h1>

    <div v-if="alert" class="my-4 p-3 bg-red-100 text-red-700 rounded">
      {{ alert }}
    </div>

    <form :action="sessionPath" method="post">
      <input type="hidden" name="authenticity_token" :value="csrfToken" />

      <div class="my-5">
        <Label>E-post</Label>
        <Input
          type="email"
          name="email_address"
          required
          autofocus
          autocomplete="username"
          placeholder="Ange din e-postadress"
          class="mt-2"
        />
      </div>

      <div class="my-5">
        <Label>Lösenord</Label>
        <Input
          type="password"
          name="password"
          required
          autocomplete="current-password"
          placeholder="Ange ditt lösenord"
          maxlength="72"
          class="mt-2"
        />
      </div>

      <div class="col-span-6 sm:flex sm:items-center sm:gap-4">
        <Button type="submit">Logga in</Button>

        <div class="mt-4 text-sm text-muted-foreground sm:mt-0 flex gap-4">
          <Link :href="newPasswordPath" class="underline hover:no-underline"
            >Glömt lösenord?</Link
          >
          <Link :href="newUserPath" class="underline hover:no-underline"
            >Skapa konto</Link
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Link } from "@inertiajs/vue3";

defineProps({
  csrfToken: { type: String, required: true },
  sessionPath: { type: String, required: true },
  newPasswordPath: { type: String, required: true },
  newUserPath: { type: String, required: true },
  alert: { type: String, default: null },
});
</script>
